import {
  configureLocalDataKeyCustody,
  type LocalAccountKekCustody,
} from '@affine/nbstore';
import type { Framework } from '@toeverything/infra';

import { ServersService } from '../cloud/services/servers';
import { LocalAccountKeys } from './local-account-keys';

export { ElectronLocalAccountKekVault } from './electron-account-key-vault';
export type { LocalAccountStoreContext } from './local-account-keys';
export { LocalAccountKeys } from './local-account-keys';

/**
 * Bootstrap supplies Web record custody or the Desktop OS-vault port
 * explicitly. The same custody serves the storages this thread opens itself
 * (workspace creation, blob deletion); the store worker sets its own.
 */
export function configureLocalDataKeysModule(
  framework: Framework,
  kekCustody: LocalAccountKekCustody
) {
  configureLocalDataKeyCustody(kekCustody);
  framework.service(
    LocalAccountKeys,
    resolver => new LocalAccountKeys(resolver.get(ServersService), kekCustody)
  );
}
